export class Catalog {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "description",
            "baseName": "description",
            "type": "string",
            "format": ""
        },
        {
            "name": "remoteCatalogType",
            "baseName": "remoteCatalogType",
            "type": "RemoteCatalogType",
            "format": ""
        },
        {
            "name": "federated",
            "baseName": "federated",
            "type": "FederatedCatalogInfo",
            "format": ""
        },
        {
            "name": "createdAt",
            "baseName": "createdAt",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "updatedAt",
            "baseName": "updatedAt",
            "type": "Date",
            "format": "date-time"
        }
    ];
    static getAttributeTypeMap() {
        return Catalog.attributeTypeMap;
    }
    constructor() {
    }
}
